<!-- Create X, Y, and Z inputs and confirm -->
<template lang="html">
  <v-dialog :value="model.active" persistent max-width="400px">
    <v-card>
      <v-card-title>
        <span class="headline">Get Point</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="model.valid">
          <v-row>
            <v-col>
              <v-text-field
								type="number"
                outlined
                dense
                v-model="selected.x"
                hide-details
                label="X (m)"
                placeholder="X"
                required>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
								type="number"
                outlined
                dense
                v-model="selected.y"
                hide-details
                label="Y (m)"
                placeholder="Y"
                required>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
								type="number"
                outlined
                dense
                v-model="selected.z"
                hide-details
                label="Z (m)"
                placeholder="Z"
                required>
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="red" elevation="0" text @click="closeDialog" :disabled="model.loading">
          close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          elevation="0"
          @click="confirm"
          :loading="model.loading"
          :disabled="!model.valid">
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
	const THREE = window.THREE;
  export default {
		name: 'PointFormDialog',
    data() {
      return {
        model: {
          active: false,
          loading: false,
          valid: false,
          hasChanges: false,
        },
        selected: {
          x: null,
          y: null,
          z: null,
        },
				onDone: null,
      };
    },
    methods: {
      open() {
        this.model.hasChanges = false;
        this.selected = {
          x: null,
          y: null,
          z: null,
        };
        this.model.active = true;
      },
      closeDialog() {
        // this.model.valid = false;
        this.model.hasChanges = false;
        this.selected = {
          x: null,
          y: null,
          z: null,
        };

        this.model.active = false;

				if (this.onDone) this.onDone(null);
      },
      confirm() {
        this.model.hasChanges = false;
				this.model.active = false;

				if (!this.selected.x || !this.selected.y || !this.selected.z) {
					this.$dialog.notify.error('Please fill in all fields');
					return;
				}

        this.selected = {
          x: parseFloat(this.selected.x),
          y: parseFloat(this.selected.y),
          z: parseFloat(this.selected.z),
        }

				if (this.onDone) this.onDone(new THREE.Vector3(this.selected.x, this.selected.y, this.selected.z));
      },
    },
  };
</script>
<style lang="scss"></style>
